module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"accuracy":"Accuracy","use":"Use","status":"GPS Location Status","notSet":"Not Set"},"es":{"accuracy":"Precisión","use":"Usar","status":"Estado de ubicación GPS","notSet":"No establecido"},"sw":{"accuracy":"Usahihi","use":"Tumia","status":"Hali ya Mahali pa GPS","notSet":"Haijawekwa"}}')
  delete Component.options._Ctor
}
